module.exports = __webpack_public_path__ + "img/new_leftImg.0e9c25e2.png";